import fetch from 'dva/fetch';
// import {isIE} from './download';
import { CHINESE, EXCEPTION_MSG, PATH_HOME, RES_STATUS } from './constants';
import { Modal } from 'antd';
import { getSign } from 'virsical-sign';
import { en_US, zh_CN } from '../i18n';

const TOKEN_KEY = 'token';
const SIGN_KEY = 'sign';

  /**
   * Requests a URL, returning a promise.
   *
   * @param  {string} url       The URL we want to request
   * @param  {object} [options] The options we want to pass to "fetch"
   * @return {object}           An object containing either "data" or "err"
   */
  export default (url, options) => {
    let signUrl = url;
    if (options && options.body) {
      signUrl =
        signUrl +
        (signUrl.indexOf('?') > -1 ? '&' : '?') +
        `body=${encodeURIComponent(options.body)}`;
    }

    let headers = {};
    let token = getUrlParam('token') || sessionStorage.getItem('token') || '';

    headers[TOKEN_KEY] = token;
    headers[SIGN_KEY] = getSign(signUrl, token);

    if (options) {
      options.headers = {
        ...options.headers,
        ...headers
      };
    } else {
      options = { headers: headers };
    }

    return new Promise(resolve => {
      resolve(requestNoToken(url, options));
    }).then(data => data); //这里不需要再catch了。
  };

export const requestNoToken = (url, options) => {
  if (options) {
    options.headers = {
      ...options.headers,
      'Content-Type': 'application/json',
      'Cache-Control': 'private, no-cache, no-store, must-revalidate',
      Expires: '-1',
      Pragma: 'no-cache'
    };
  } else {
    options = {
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'private, no-cache, no-store, must-revalidate',
        Expires: '-1',
        Pragma: 'no-cache'
      }
    };
    //   if (isIE()) {
    //     url += `${url.indexOf('?') > -1 ? '&' : '?'}t=${Date.now()}`;
    //   }
  }
  return fetch(url, options)
    .then(checkStatus)
    .then(response => response.json())
    .then(checkResponseStatus)
    .catch(err => {
      throw err;
    });
};

const checkStatus = response => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  let errMsg = response.statusText;
  const lang = localStorage.getItem('lang') || localStorage.getItem('locale');
  let errMsgTip = '';
  if ('' !== response.statusText) {
    errMsgTip =
      lang && lang === CHINESE
        ? EXCEPTION_MSG.zh_err_tip
        : EXCEPTION_MSG.en_err_tip;
  }
  if (response.status >= 400 && response.status < 500) {
    if (lang && lang === CHINESE) {
      errMsg = EXCEPTION_MSG.zh_40x + errMsgTip + response.statusText;
    } else {
      errMsg = EXCEPTION_MSG.en_40x + errMsgTip + response.statusText;
    }
  }
  if (response.status >= 500) {
    if (lang && lang === CHINESE) {
      errMsg = EXCEPTION_MSG.zh_50x + errMsgTip + response.statusText;
    } else {
      errMsg = EXCEPTION_MSG.en_50x + errMsgTip + response.statusText;
    }
  }
  return Promise.reject(errMsg)
};

let failModalRef = null;//token失效的modal只弹一次
const checkResponseStatus = data => {
  if (data && data.status === RES_STATUS.tokenFail) {
    //token失效处理
    const lang = localStorage.getItem('lang') || localStorage.getItem('locale');
    let okText = '';
    if (CHINESE === lang) {
      okText = zh_CN['dialog_btn_ok'];
    } else {
      okText = en_US['dialog_btn_ok'];
    }
    if(!failModalRef){
      failModalRef = Modal.error({
        title: data.msg,
        okText,
        onOk: () => {
          window.location.href = PATH_HOME;
        }
      });
    }
    return Promise.reject(data.msg);
  }
  return data;
};

//获取URL地址的参数值。
//name为URL参数名
//例如：?param1=abc&param2=123
//当调用GetURLparam("param2"）时，获取到的值为：123
export const getUrlParam = name => {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  const r = window.location.search.substr(1).match(reg);
  if (r !== null) return r[2];
  return null;
};



// WEBPACK FOOTER //
// ./src/utils/request.js